import CircleProgressBar from './circle-progress-bar';

export default CircleProgressBar;